import { Card, CardContent, Grid, Typography, Checkbox, Option, SelectField } from "@deere/fuel-react";
import { useState, useEffect } from "react";
import SelfServiceButtons from "../SelfServiceButtons";
import { LANGUAGE_TITLE, DEFAULT_LANGUAGE_CODE, LBL_TEXT_HTML, LBL_LANGUAGESELECTION, LBL_ROWEMAILBODY, LBL_SELECTION, LBL_ROW, LBL_EMAILCONTENTBODY, FETCHING_DATA, SAVING_DATA } from "../../../../utils/surveyLiterals";
import { ERR_LANGUAGE_STEP } from "../../../../utils/errorLiterals";
import { sortByLanguageList, buildDefaultSectionTranslations } from "../../../../utils/utils";
import SelfServiceLoader from "../SelfServiceLoader";

const LanguageStep = ({ languageValidation, setLanguageValidation, currentStep, activeStep, setActiveStep, setPayloadData, payloadData, languageList, emailTemplateData }) => {
  const languageValue = payloadData && payloadData.language ? payloadData.language.map((lng) => lng.languageCd) : [];
  const [loader, setLoader] = useState({isLoading: true, message: FETCHING_DATA});

  useEffect(() => {
    if (languageList && languageList.length > 0)
      setLoader({ isLoading: false, message: "" });
  }, [languageList]);

  const fnValidate = (publishHandler) => {
    payloadData && payloadData.language && payloadData.language.length === 0
      ? setLanguageValidation(true)
      : (setLoader({ isLoading: true, message: SAVING_DATA }), publishHandler(payloadData));
  };

  const languageChangeHandler = (e) => {
    const selectedLanguages = e.target.value.map((value) => {
      const langName = languageList.find((ln) => ln.languageCd === value);
      return { languageCd: value, text: langName ? langName.language : "" };
    });
    setLanguageValidation(false);
    setPayloadData((prevState) => {
      const newState = removeTranslations(prevState, e.target.value);
      const newLang = [...newState.language];
      selectedLanguages.forEach((ln) => {
        const index = newLang.findIndex((nln) => nln.languageCd === ln.languageCd);
        if(index === -1)  newLang.push(ln)
      });
      return { ...newState, language: newLang, surveyNotification: configureEmailTemplate(newLang, newState.surveyNotification), sections: configureSections(newLang, newState.sections) };
    });
  };

  const renderSelectedValues = (selectedLanguages) => {
    let returnValue = "";
    selectedLanguages.forEach((lang, index) => {
      const language = languageList.find((ln) => ln.languageCd === lang);
      if (language) returnValue += index === selectedLanguages.length - 1 ? language.language : language.language + ", ";
    });
    return sortByLanguageList(returnValue, languageList);
  };

  const switchlanguageCheckbox = (langValue) => {
    const index = payloadData && payloadData.language ? payloadData.language.findIndex((lng) => lng.languageCd === langValue) : -1;
    return index === -1 ? false : true;
  };

  const removeTranslations = (payloadObj, arrLang) => {
    if (payloadObj && payloadObj.language) { //Survey Languages
      payloadObj.language = payloadObj.language.filter((ln) => arrLang.includes(ln.languageCd));
    }
    if (payloadObj && payloadObj.translations) { //Survey Title Translations
      payloadObj.translations = payloadObj.translations.filter((t) => arrLang.includes(t.locale));
    }
    if (payloadObj && payloadObj.defaultColumns) { //Survey Additional Column Translations
      payloadObj.defaultColumns.forEach((col) => {
        col.translations = col?.translations?.filter((t) => arrLang.includes(t.locale)) || [];
      });
    }
    if (payloadObj && payloadObj.sections) { //Survey Section/Question/Selections Translations
      payloadObj.sections.forEach((sec) => {
        sec.translations = sec.translations.filter((secTrn) => arrLang.includes(secTrn.locale));
        if (sec.questions) {
          sec.questions.forEach((que) => {
            que.translations = que.translations.filter((queTrn) => arrLang.includes(queTrn.locale));
            if (que.selections) {
              que.selections.forEach((sel) => {
                sel.translations = sel.translations.filter((selTrn) => arrLang.includes(selTrn.locale));
              })
            }
          });
        }
      });
    }
    if (payloadObj && payloadObj.helpDocs) { //Survey Help Document Translations
      payloadObj.helpDocs = payloadObj.helpDocs.filter((hd) => arrLang.includes(hd.languageCd));
    }
    return payloadObj;
  };

  const configureEmailTemplate = (selectedLanguages, oldPayloadTemplate) => {
    if (!oldPayloadTemplate || oldPayloadTemplate === "") return "";
    const parser = new DOMParser();
    const doc = parser.parseFromString(oldPayloadTemplate, LBL_TEXT_HTML);
    const listItems = doc.getElementsByClassName(LBL_LANGUAGESELECTION);
    const tableRows = doc.getElementsByClassName(LBL_ROWEMAILBODY);
    const emailContentBody = doc.getElementById(LBL_EMAILCONTENTBODY);
    for (let i=listItems.length-1; i>=0; i--) {
      const index = selectedLanguages.findIndex((sl) => `${LBL_SELECTION}${sl.text}` === listItems[i].id);
      if (index === -1) listItems[i].remove();
    }
    for (let i=tableRows.length-1; i>=0; i--) {
      const index = selectedLanguages.findIndex((sl) => `${LBL_ROW}${sl.text}` === tableRows[i].id);
      if (index === -1) tableRows[i].remove();
    }
    const selectedLanguageIds = new Set(selectedLanguages.map(sl => `${LBL_SELECTION}${sl.text}`));
    const selectedLanguageRows = new Set(selectedLanguages.map(sl => `${LBL_ROW}${sl.text}`));
    emailTemplateData.forEach(content => {
      const listItemId = `${LBL_SELECTION}${content.language}`;
      const tableRowId = `${LBL_ROW}${content.language}`;
      if (selectedLanguageIds.has(listItemId) && !doc.getElementById(listItemId)) {
          const newListItem = document.createElement('li');
          newListItem.innerHTML = content.listItem;
          newListItem.id = listItemId;
          newListItem.className = LBL_LANGUAGESELECTION;
          emailContentBody?.querySelector('ul').appendChild(newListItem.firstChild);
      }
      if (selectedLanguageRows.has(tableRowId) && !doc.getElementById(tableRowId)) {
          const newTableRow = document.createElement('tr');
          newTableRow.innerHTML = content.tableRow;
          newTableRow.id = tableRowId;
          newTableRow.className = LBL_ROWEMAILBODY;
          emailContentBody?.appendChild(newTableRow);
      }
  });
    return doc.documentElement.outerHTML;
  };

  const configureSections = (selectedLanguages, sections) => {
    sections.forEach((sec) => {
      if (sec.isDefault) {
        sec.translations = buildDefaultSectionTranslations(sec, selectedLanguages);
      }
    });
    return sections;
  };

  return (
    <>
      <Card>
        <CardContent>
          {loader.message !== "" ? (
            <SelfServiceLoader loader={loader} />
          ) : (
            <Grid container direction="column" justifyContent="space-between" minHeight={"60vh"} rowSpacing={4}>
              <Grid item>
                <Typography variant="h1">
                  {currentStep.step} - {currentStep.title}
                </Typography>
              </Grid>
              <Grid item pl={5} pr={5}>
                <SelectField label={LANGUAGE_TITLE} multiple value={languageValue} renderValue={renderSelectedValues} onChange={languageChangeHandler}>
                  {languageList
                    .sort((a, b) => (a.id > b.id ? 1 : -1))
                    .map((lang) => (
                      <Option key={lang.languageCd} value={lang.languageCd} hidden={lang.languageCd === DEFAULT_LANGUAGE_CODE}>
                        <Checkbox checked={switchlanguageCheckbox(lang.languageCd)} />
                        {lang.language}
                      </Option>
                    ))}
                </SelectField>
              </Grid>
              <Grid item pr={5}>
                {languageValidation && (
                  <Typography variant="subtitle1" color="#C21020" textAlign="right">
                    {ERR_LANGUAGE_STEP}
                  </Typography>
                )}
                <Grid container justifyContent="flex-end" mt={3}>
                  <SelfServiceButtons
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    fnValidate={fnValidate}
                    payloadData={payloadData}
                    setPayloadData={setPayloadData}
                    setLoader={setLoader}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}
        </CardContent>
      </Card>
    </>
  );
};

export default LanguageStep;
